import { Directive } from '@angular/core';
import {SharedScrollEndNotifierDirective } from '@seech/shared-ng';
@Directive({
  selector: '[sch-scroll-end-notifier]',
  standalone: true,
})
export class ScrollEndNotifierDirective extends SharedScrollEndNotifierDirective {

}
